import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import dateFormat from 'dateformat';

import Footer from '../../../Components/Footer/Footer';
import Auth from '../../Authentication/Auth';
import Api from '../../../Services/Api';

import FuelTruckGroupDetails from './FuelTruckGroupDetails';

const ONE_DAY = 24 * 60 * 60 * 1000;

class FuelTrucksPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      queryDate: new Date().getTime(),
      trucks: undefined,
      overallTotal: 0,
      schoolTotal: 0,
    };

    this.prevDateButtonClicked = this.prevDateButtonClicked.bind(this);
    this.nextDateButtonClicked = this.nextDateButtonClicked.bind(this);
    this.calculateTotal = this.calculateTotal.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.props.fboId}/reports/fuelTrucks?timestamp=${this.state.queryDate}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const trucks = response.report.fuelTrucks;

      // Clear trucks before reloading data
      // if the data isn't cleared sub-UI components won't reload
      this.setState(
        { trucks: undefined },
        () => this.setState({ trucks })
      );

      this.calculateTotal(trucks);
      this.calculateSchoolTotal(trucks);
    }).catch((err) => {
      console.log(err);
    });
  }

  calculateTotal(trucks) {
    let total = 0;
    trucks.forEach((truck) => {
      const meters = truck.fuelTanks[0].fuelMeters;
      meters.forEach((meter) => {
        meter.fuelOrders.forEach((fuelOrder) => {
          total += fuelOrder.totalQuantityAdded;
        });
      });
    });

    this.setState({ overallTotal: total });
  }

  calculateSchoolTotal(trucks) {
    let total = 0;
    trucks.forEach((truck) => {
      const meters = truck.fuelTanks[0].fuelMeters;
      meters.forEach((meter) => {
        meter.fuelOrders.forEach((fuelOrder) => {
          if (fuelOrder.order.aircraft) {
            total += fuelOrder.totalQuantityAdded;
          }
        });
      });
    });

    this.setState({ schoolTotal: total });
  }

  handlePrint() {
    window.print();
  }

  prevDateButtonClicked() {
    this.setState({ queryDate: this.state.queryDate - ONE_DAY }, () => {
      this.fetchData();
    });
  }

  nextDateButtonClicked() {
    this.setState({ queryDate: this.state.queryDate + ONE_DAY }, () => {
      this.fetchData();
    });
  }

  renderTotal(title, total) {
    const formattedTotal = Number.parseFloat(total).toFixed(1);
    return (
      <article className="order-item">
        <span className="right">
          <strong>{title}: {formattedTotal} Gal</strong>
        </span>
      </article>
    );
  }

  renderOrderGroup(truck) {
    return (<FuelTruckGroupDetails
      key={truck.id}
      truck={truck}
    />);
  }

  renderOrders() {
    if (this.state.trucks && this.state.trucks.length > 0) {
      return this.state.trucks.map(truck =>
        this.renderOrderGroup(truck));
    }
    return (<article className="no-order-item">No completed fuel orders</article>);
  }

  render() {
    return (
      <div className="app">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <main className="page-content">
          <div className="reports-logo"><img src="https://pictures.dealer.com/t/tomwoodaviation/1142/45644ba64046387201eb9fdee519ecec.jpg" /></div>
          <div className="orders-page-header">
            <h1>Fuel Trucks Report</h1>
            <div className="date-navigation">
              <button className="prev" onClick={this.prevDateButtonClicked}> &#60; </button>
              <button className="next" onClick={this.nextDateButtonClicked}> &#62; </button>
            </div>
            <h3>{dateFormat(this.state.queryDate, 'fullDate')}</h3>
            <button
              className="btn btn-medium btn-primary right btn-print"
              onClick={this.handlePrint}
            >
              Print
            </button>
          </div>
          <section className="order-group">
            {this.renderOrders()}
            {this.renderTotal('Grand Total', this.state.overallTotal)}
            {this.renderTotal('Total For: Flight School', this.state.schoolTotal)}
          </section>
          <Footer />
        </main>
      </div>
    );
  }
}

FuelTrucksPage.propTypes = {
  fboId: PropTypes.number.isRequired,
};

export default FuelTrucksPage;




// WEBPACK FOOTER //
// ./src/Containers/Reports/FuelTrucks/FuelTrucksPage.js